import type { TriggerReportJobRequestPayload } from '@vy/api-definition';
import type { ReportData } from '@vy/types';
import { ReportDataSchema } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useQueryClient } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useTriggerReportJob(
  options?: UseMutationOptions<ReportData, unknown, TriggerReportJobRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (triggerReportJobRequest) => {
      const api = getPrivateApi();
      const triggerReportJobQuery = await api.triggerReportJob({
        triggerReportJobRequest,
      });

      return ReportDataSchema.parse(triggerReportJobQuery);
    },
    {
      onSuccess: async () => queryClient.invalidateQueries(queryKeys.reports()),
      ...options,
    },
  );
}
